<template>
  <div class="reviews-list shop-reviews-list container pt-30 pb-50">
    <b-loading :active.sync="isLoading" :can-cancel="false" />
    <message-area />
    <div class="tile is-ancestor">
      <div class="tile is-1 is-vertical is-parent">
        <div class="tile is-child">
          <div class="mb-10">
            <div class="img-resize img-resize--large mr-50">
              <img
                :src="
                  shopDetail.image && shopDetail.image[0]
                    ? shopDetail.image[0]
                    : require('@/assets/images/shop_default.svg')
                "
                alt="..."
                class="img-thumbnail"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="tile is-parent sss">
        <div class="tile is-child">
          <h5 class="text-title">{{ shopDetail.name }}</h5>
          <table>
            <td>
              <div class="reviews-block">
                <div class="mb-20">
                  <div
                    :class="[pagination.size === 'sm' ? 'rate_sm' : 'rate_lg']"
                  >
                    <table>
                      <tr>
                        <td
                          :class="[
                            pagination.size === 'sm'
                              ? 'width_td_first_sm'
                              : 'width_td_first_lg'
                          ]"
                        >
                          <star-rating
                            :rating="reviewAvg"
                            :star-size="32"
                            :show-rating="false"
                            :read-only="true"
                            :increment="0.1"
                          ></star-rating>
                        </td>
                        <td>
                          <div class="number_rate">
                            <span
                              :class="[
                                pagination.size === 'sm'
                                  ? 'size_text_first_sm'
                                  : 'size_text_first_lg'
                              ]"
                              class="text-bold"
                            >
                              {{ reviewAvg }}</span
                            >（{{ shopDetail.numOfReview }}件）
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div v-if="statisticPercent.length > 1" class="mt-10">
                    <table>
                      <tr v-for="index in 5" :key="index">
                        <td
                          :class="[
                            pagination.size === 'sm'
                              ? 'rate_chirld_sm'
                              : 'rate_chirld_lg'
                          ]"
                          class="vertical-inherit"
                        >
                          <star-rating
                            :rating="6 - index"
                            :star-size="14"
                            :show-rating="false"
                            :read-only="true"
                            :increment="0.1"
                          ></star-rating>
                        </td>
                        <td
                          :class="[
                            pagination.size === 'sm'
                              ? 'prosess_chirld_sm'
                              : 'prosess_chirld_lg'
                          ]"
                          class="vertical-inherit"
                        >
                          <progress
                            :value="
                              statisticPercent[6 - index]
                                ? statisticPercent[6 - index]
                                : 0
                            "
                            class="progress is-warning is-small"
                            max="100"
                          ></progress>
                        </td>
                        <td class="c-text-blue">
                          {{ statisticPercent[6 - index] }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </td>
          </table>
        </div>
      </div>
    </div>

    <nav
      class="level reviews-filter"
      style="border-bottom: 1px #ebeaf9 solid; padding-bottom: 20px"
    >
      <!-- Left side -->
      <div class="level-left"><div class="level-item" /></div>
      <!-- Right side -->
      <div class="level-right">
        <div class="level-item">
          <span class="mr-10">並べ替え</span>

          <b-field label="">
            <b-select v-model.number="sortType" placeholder="新着順">
              <option :value="1">新着順</option>
              <option :value="0">投稿順</option>
            </b-select>
          </b-field>
        </div>
      </div>
    </nav>

    <item-shop-reviews
      v-for="(review, index) in reviews"
      :data="review"
      :show-link-detail="true"
      :key="index"
    />
    <div class="text-center pb-50">
      <b-pagination
        v-show="showPagination"
        :total="pagination.total"
        :current.sync="pagination.current + 1"
        :per-page="pagination.perPage"
        :simple="false"
        :rounded="false"
        order="is-centered"
        @change="pageChange"
      />
    </div>
  </div>
</template>
<style lang="scss" src="./list.scss" scoped>
</style>

<script>
import MessageArea from '@/components/common/message-area/message-area.vue';
import ItemShopReviews from '../../../customer/components/item-reviews/item-shop-reviews';
import messageUtils from '../../../../utils/mixins/messageUtils';
import { getShopInfo, getStatisticReview } from '../../../../services/shop.service';
import { getListReviewsShop } from '../../../../services/review.service';
import StarRating from 'vue-star-rating';

export default {
  name: 'ShopReviews',
  components: {
    'item-shop-reviews': ItemShopReviews,
    'message-area': MessageArea,
    StarRating
  },
  mixins: [messageUtils],
  data() {
    return {
      shopId: null,
      shopDetail: {},
      reviews: [],
      statistic: [],
      sortType: 1,
      pagination: {
        total: 0,
        current: 0,
        perPage: 10,
        order: '',
        size: '',
        isSimple: false,
        isRounded: false
      }
    };
  },
  computed: {
    reviewAvg: function() {
      let result = 0;
      if (this.shopDetail.totalPointReview && this.shopDetail.numOfReview !== 0) {
        result = Math.round(parseFloat(this.shopDetail.totalPointReview / this.shopDetail.numOfReview) * 100) / 100;
      }
      return result;
    },
    statisticPercent: function() {
      const result = [0];
      // result.push((this.statistic.oneStar*100 / this.totalReview).toFixed());
      const totalReview = this.shopDetail.numOfReview || 1;
      result.push(Math.round((this.statistic.oneStar * 100) / totalReview));
      result.push(Math.round((this.statistic.twoStar * 100) / totalReview));
      result.push(Math.round((this.statistic.threeStar * 100) / totalReview));
      result.push(Math.round((this.statistic.fourStar * 100) / totalReview));
      result.push(Math.round((this.statistic.fiveStar * 100) / totalReview));
      return result;
    },
    showPagination: function() {
      return this.pagination && this.pagination.total > this.pagination.perPage;
    }
  },
  watch: {
    sortType: function(value) {
      console.log(`reviews-list.vue - (299) - `, value);
      this.getReviews(value);
    }
  },
  created() {
    this.shopId = this.$route.params.shopId;
    this.getShopDetail();
    this.getReviews();
    this.getStatistic();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    async getShopDetail() {
      this.loading++;
      const { status, result } = await getShopInfo(this.shopId);
      if (status) {
        this.shopDetail = result.data;
      } else {
        this.updateMessage(status, result);
      }
      this.loading--;

      console.log(`form.vue - (112) - `, result);
    },
    async getReviews() {
      this.loading++;
      this.reviews = [];
      const { status, result } = await getListReviewsShop(
        this.shopId,
        this.pagination.current,
        this.pagination.perPage,
        this.sortType
      );
      if (status && result.data) {
        this.reviews = result.data.reviews;
        this.pagination.total = result.data.count;
      } else {
        this.updateMessage(status, result);
      }
      this.loading--;
    },
    async getStatistic() {
      this.loading++;

      const { status, result } = await getStatisticReview(this.shopId);
      console.log(`reviews-list.vue - (163) - `, result);
      if (status) {
        this.statistic = result.data;
      } else {
        this.updateMessage(status, result);
      }
      this.loading--;
    },
    handleResize() {
      console.log(7777, window.innerWidth);
      if (window.innerWidth >= 1500) {
        this.per_page_bottom = 10;
      } else if (window.innerWidth < 1500 && window.innerWidth >= 1120) {
        this.per_page_bottom = 7;
      } else if (window.innerWidth < 1120 && window.innerWidth >= 800) {
        this.per_page_bottom = 5;
      } else {
        this.per_page_bottom = 5;
      }
    },
    async pageChange(page) {
      this.pagination.current = page - 1;
      await this.getReviews();
    }
  }
};
</script>
